(function() {

  // ── Core product config ──────────────────────────────────────────────────
  var PRODUCT_HANDLE = 'purahome-stainless-steel-tap-water-filter';
  var DEFAULT_VARIANT_TITLE = '1-year (8 Filters)';

  function detectProductHandle() {
    try {
      if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta &&
          window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.handle) {
        return window.ShopifyAnalytics.meta.product.handle;
      }
    } catch (e) {}
    try {
      if (window.meta && window.meta.product && window.meta.product.handle) {
        return window.meta.product.handle;
      }
    } catch (e) {}
    try {
      var match = window.location.pathname.match(/\/products\/([^\/\?#]+)/);
      if (match) return match[1];
    } catch (e) {}
    return PRODUCT_HANDLE;
  }

  var CURRENCY_SYMBOLS = {
    'AUD': '$', 'USD': '$', 'CAD': '$', 'NZD': '$', 'SGD': '$', 'HKD': '$',
    'GBP': '\u00a3', 'EUR': '\u20ac', 'JPY': '\u00a5', 'CNY': '\u00a5', 'INR': '\u20b9',
    'CHF': 'Fr', 'SEK': 'kr', 'NOK': 'kr', 'DKK': 'kr', 'ZAR': 'R',
    'MXN': '$', 'BRL': 'R$', 'AED': '\u062f.\u0625', 'THB': '\u0e3f', 'MYR': 'RM',
    'PHP': '\u20b1', 'KRW': '\u20a9', 'TRY': '\u20ba',
  };

  var VARIANT_ORDER = [
    '1-year (8 Filters)',
    '6-months (4 Filters)',
    '3-months (2 Filters)',
  ];

  var VARIANT_META = {
    '1-year (8 Filters)': {
      label: '1 Year Supply',
      sublabel: '(Filter System + 8 Filters)',
      sublabelShort: '8 Filters',
      days: 365,
      isBestValue: true,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/3_995b8e44-38a0-4e25-9471-a3a9c38e421d.png?v=1781932651'
    },
    '6-months (4 Filters)': {
      label: '6 Month Supply',
      sublabel: '(Filter System + 4 Filters)',
      sublabelShort: '4 Filters',
      days: 182,
      isBestValue: false,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/4_f83c21da-81c8-4e88-94d3-9a241f59272c.png?v=1781932650'
    },
    '3-months (2 Filters)': {
      label: '3 Month Supply',
      sublabel: '(Filter System + 2 Filters)',
      sublabelShort: '2 Filters',
      days: 91,
      isBestValue: false,
      image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/5_ae454446-23b8-4170-961b-3ec598209f15.png?v=1781932650'
    },
  };

  var VARIANT_SCARCITY = {
    '1-year (8 Filters)':   { pctClaimed: 88, label: 'sold out', color: '#ef4444' },
    '6-months (4 Filters)': { pctClaimed: 42, label: 'sold out', color: '#f97316' },
    '3-months (2 Filters)': { pctClaimed: 18, label: 'sold out', color: '#01b778' },
  };

  var AFTERPAY_CURRENCIES = ['AUD', 'NZD', 'USD', 'CAD', 'GBP'];
  var AFTERPAY_LOGO_URL = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/after-pay.svg?v=1752685514';

  var COLOR_NAVY        = '#1e2764';
  var COLOR_BLUE        = '#2a5bd7';
  var COLOR_BORDER_BLUE = '#4f46e5';
  var COLOR_GREEN       = '#01b778';
  var COLOR_GRAY_TEXT   = '#6b7280';
  var COLOR_GRAY_BORDER = '#d8dce3';
  var COLOR_BLACK       = '#111827';
  var COLOR_UPSELL_FILL = '#eef0fc';

  var UPSELLS = [
    {
      handle: 'purahome\u2122-360-faucet-aerator',
      name: 'PuraHome 360\u00b0 Faucet Aerator',
      shortName: '360\u00b0 Aerator',
      blurb: 'Pairs directly with your filter tap \u2014 wide-angle spray, two water modes.',
      image: 'https://mypurahome.com/cdn/shop/files/02261-ezgif.com-optimize.gif?v=1772065543'
    },
    {
      handle: 'purahome\u2122-premium-shower-filter',
      name: 'Premium In-line Shower Filter',
      shortName: 'Shower Filter',
      blurb: 'Reduces chlorine & heavy metals in shower water for softer skin and hair.',
      image: 'https://mypurahome.com/cdn/shop/files/1_f1933fdf-ddaa-4553-b774-b2a387bdaedd.png?v=1761267193'
    },
    {
      handle: 'purahome\u2122-vitamin-c-bathroom-filter',
      name: 'Vitamin C Bathroom Sink Filter',
      shortName: 'Bathroom Filter',
      blurb: 'Filters chlorine & microplastics at the bathroom tap for softer skin.',
      image: 'https://mypurahome.com/cdn/shop/files/1_8b00d810-4cff-4b76-bb71-0a65f7516790.png?v=1761267193'
    }
  ];

  var UPSELLS_HEADING = 'Complete Your Order';
  var POST_ADD_REDIRECT = '/cart';

  var state = {
    variants: [],
    currentVariantId: null,
    currency: 'AUD',
    quantity: 1,
    upsells: [],
    selectedUpsells: {}
  };

  var bridgeChangeListeners = [];

  function getCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      ? window.Shopify.currency.active : 'AUD';
  }

  function getCurrencySymbol(currency) {
    return CURRENCY_SYMBOLS[currency] || '$';
  }

  function formatMoney(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(amount);
    } catch(e) { return '$' + amount.toFixed(2); }
  }

  function formatMoneyNoDecimal(amount, currency) {
    try {
      var symbol = getCurrencySymbol(currency);
      return symbol + new Intl.NumberFormat(undefined, {
        minimumFractionDigits: 0, maximumFractionDigits: 0
      }).format(amount);
    } catch(e) { return '$' + Math.round(amount); }
  }

  function formatPerDay(price, days, currency) {
    var symbol = getCurrencySymbol(currency);
    return symbol + (price / days).toFixed(2) + '/day';
  }

  function getCurrentVariant() {
    for (var i = 0; i < state.variants.length; i++) {
      if (state.variants[i].id == state.currentVariantId) return state.variants[i];
    }
    return null;
  }

  function getCtaLabel(variant) {
    if (variant.compare_price && variant.compare_price > variant.price) {
      var pct = Math.round((1 - variant.price / variant.compare_price) * 100);
      return 'Buy Now & Save ' + pct + '%';
    }
    return 'Buy Now';
  }

  function openFilterLifespanPopup() {
    openSimpleModal('How Long Does Each Filter Last?',
      '<div style="padding:18px;font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.7;">' +
      '<p style="margin:0 0 12px;">Each PuraHome filter typically lasts <strong style="color:' + COLOR_NAVY + ';">1.5\u20133 months</strong>, depending on two things:</p>' +
      '<ul style="margin:0 0 14px;padding-left:18px;">' +
      '<li style="margin-bottom:6px;"><strong style="color:' + COLOR_NAVY + ';">Your local water quality</strong> \u2014 harder or more contaminated water will work the filter harder and shorten its life.</li>' +
      '<li><strong style="color:' + COLOR_NAVY + ';">Your daily usage</strong> \u2014 the more water you filter each day, the faster a filter is used up.</li>' +
      '</ul>' +
      '<p style="margin:0 0 12px;">We size each supply pack for <strong style="color:' + COLOR_NAVY + ';">1 year at average usage</strong> \u2014 so if your water quality is typical or above average, your pack could easily last <strong style="color:' + COLOR_NAVY + ';">up to 2 years</strong>.</p>' +
      '<div style="background:' + COLOR_UPSELL_FILL + ';border-radius:10px;padding:12px 14px;font-size:13px;color:' + COLOR_NAVY + ';font-weight:600;">' +
      '\ud83d\udca1 The price per day shown on each option reflects the best-case cost \u2014 based on each filter lasting its full 3 months, giving you maximum value from your supply.' +
      '</div>' +
      '</div>'
    );
  }

  function buildSupplyHeading() {
    var existing = document.getElementById('ph2-supply-heading');
    if (existing) existing.parentNode.removeChild(existing);
    var existingAp = document.getElementById('ph2-ap-top');
    if (existingAp) existingAp.parentNode.removeChild(existingAp);

    var apBlock = document.createElement('div');
    apBlock.id = 'ph2-ap-top';
    apBlock.style.cssText = 'margin-bottom:14px;';

    var apSep = document.createElement('hr');
    apSep.style.cssText = 'border:none;border-top:1px solid #e5e7eb;margin:0 0 12px;';
    apBlock.appendChild(apSep);

    var apInner = document.createElement('div');
    apInner.style.cssText = 'display:flex;flex-direction:column;width:100%;background:#f5f7ff;border:1px solid #e5e7eb;border-radius:10px;padding:12px 16px;gap:3px;box-sizing:border-box;';

    var apRow = document.createElement('div');
    apRow.style.cssText = 'display:flex;align-items:center;gap:7px;flex-wrap:wrap;';

    var apAmt = document.createElement('span');
    apAmt.id = 'ph2-ap-top-amount';
    apAmt.style.cssText = 'font-size:20px;font-weight:800;color:' + COLOR_BLUE + ';line-height:1;';
    if (window.innerWidth < 480) apAmt.style.fontSize = '17px';
    apAmt.textContent = '';

    var apX4 = document.createElement('span');
    apX4.style.cssText = 'font-size:14px;color:#111827;font-weight:700;';
    apX4.textContent = 'x 4';

    var apWith = document.createElement('span');
    apWith.style.cssText = 'font-size:14px;color:#9ca3af;';
    apWith.textContent = 'with';

    var apLogo = document.createElement('img');
    apLogo.src = AFTERPAY_LOGO_URL;
    apLogo.alt = 'Afterpay';
    apLogo.style.cssText = 'height:17px;width:auto;display:block;';

    apRow.appendChild(apAmt);
    apRow.appendChild(apX4);
    apRow.appendChild(apWith);
    apRow.appendChild(apLogo);
    apInner.appendChild(apRow);

    var apTotal = document.createElement('div');
    apTotal.id = 'ph2-ap-top-total';
    apTotal.style.cssText = 'font-size:11px;font-weight:700;color:#9ca3af;';
    apTotal.textContent = '';
    apInner.appendChild(apTotal);

    apBlock.appendChild(apInner);

    var heading = document.createElement('div');
    heading.id = 'ph2-supply-heading';
    heading.style.cssText =
      'font-size:16px;font-weight:700;color:' + COLOR_BLACK + ';border-top:1px solid #e3e5eb;' +
      'padding-top:14px;margin-bottom:12px;display:flex;align-items:center;gap:7px;';

    var label = document.createElement('span');
    label.innerHTML = 'Filter Supply: <span id="ph2-supply-heading-value" style="color:' + COLOR_NAVY + ';"></span>';
    heading.appendChild(label);

    var infoBtn = document.createElement('button');
    infoBtn.type = 'button';
    infoBtn.setAttribute('aria-label', 'Filter lifespan info');
    infoBtn.style.cssText =
      'flex:0 0 auto;width:18px;height:18px;border-radius:50%;background:' + COLOR_NAVY + ';' +
      'border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;' +
      'color:#fff;font-size:11px;font-weight:700;line-height:1;padding:0;';
    infoBtn.textContent = 'i';
    infoBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      openFilterLifespanPopup();
    });
    heading.appendChild(infoBtn);

    var picker = document.getElementById('ph2-picker');
    picker.parentNode.insertBefore(heading, picker);
    picker.parentNode.insertBefore(apBlock, heading);
  }

  function applyPricing() {
    var variant = getCurrentVariant();
    if (!variant) return;
    var currency = state.currency;

    var headingValue = document.getElementById('ph2-supply-heading-value');
    if (headingValue) headingValue.textContent = variant.title;

    var ctaBtn = document.getElementById('ph2-buy-btn');
    if (ctaBtn) ctaBtn.textContent = getCtaLabel(variant);

    updateAfterpay();

    state.variants.forEach(function(v) {
      var card = document.querySelector('.ph2-card[data-variant-id="' + v.id + '"]');
      if (!card) return;

      var vMeta     = VARIANT_META[v.title] || { days: 365 };
      var vPrice    = v.price;
      var compPrice = v.compare_price;

      var pctPill  = card.querySelector('.ph2-pct-pill');
      var soldPill = card.querySelector('.ph2-sold-pill');

      if (!v.available) {
        card.classList.add('ph2-sold-out');
        card.style.opacity = '0.5';
        card.style.pointerEvents = 'none';
        if (soldPill) soldPill.style.display = 'block';
        if (pctPill)  pctPill.style.display  = 'none';
      } else {
        card.classList.remove('ph2-sold-out');
        card.style.opacity = '';
        card.style.pointerEvents = '';
        if (soldPill) soldPill.style.display = 'none';
        if (compPrice && compPrice > vPrice && pctPill) {
          var pct = Math.round((1 - vPrice / compPrice) * 100);
          pctPill.textContent = pct + '% OFF';
          pctPill.style.display = '';
        } else if (pctPill) {
          pctPill.style.display = 'none';
        }
      }

      var comparePriceEl = card.querySelector('.ph2-card-compare');
      if (comparePriceEl) {
        if (compPrice && compPrice > vPrice) {
          comparePriceEl.textContent = formatMoneyNoDecimal(compPrice, currency);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      var bigPriceEl = card.querySelector('.ph2-card-perday-main');
      if (bigPriceEl) bigPriceEl.textContent = formatMoneyNoDecimal(vPrice, currency);

      var billedEl = card.querySelector('.ph2-card-billed');
      if (billedEl) billedEl.textContent = formatPerDay(vPrice, vMeta.days * 2, currency);

      var scarcityBar  = card.querySelector('.ph2-scarcity-bar-fill');
      var scarcityText = card.querySelector('.ph2-scarcity-text');
      var scarcityData = VARIANT_SCARCITY[v.title];
      if (scarcityBar && scarcityText && scarcityData) {
        var c = scarcityData.color || '#ef4444';
        scarcityBar.style.width = Math.min(scarcityData.pctClaimed, 99) + '%';
        scarcityBar.style.background = c;
        scarcityText.textContent = scarcityData.pctClaimed + '% ' + scarcityData.label;
        scarcityText.style.color = c;
      }
    });

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    bridgeChangeListeners.forEach(function(cb) {
      try { cb(); } catch (e) { console.error('[PH2] Bridge listener error \u2014', e); }
    });
  }

  function highlightCard(variantId, container) {
    container.querySelectorAll('.ph2-card').forEach(function(c) {
      var selected = c.getAttribute('data-variant-id') == variantId;
      c.classList.toggle('ph2-selected', selected);
      c.style.borderColor = selected ? COLOR_BORDER_BLUE : COLOR_GRAY_BORDER;
      c.style.background  = selected ? COLOR_UPSELL_FILL : '#fff';
    });
  }

  function buildCards(variants, currency, container) {
    container.innerHTML = '';

    variants = variants.filter(function(v) { return VARIANT_ORDER.indexOf(v.title) !== -1; });
    variants.sort(function(a, b) {
      var ai = VARIANT_ORDER.indexOf(a.title);
      var bi = VARIANT_ORDER.indexOf(b.title);
      if (ai === -1) ai = 999;
      if (bi === -1) bi = 999;
      return ai - bi;
    });

    state.variants = variants;
    state.currency = currency;

    var defaultVariant = null;
    variants.forEach(function(v) {
      if (v.title === DEFAULT_VARIANT_TITLE && v.available) defaultVariant = v;
    });
    if (!defaultVariant) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].available) { defaultVariant = variants[i]; break; }
      }
    }
    if (!defaultVariant) defaultVariant = variants[0];
    state.currentVariantId = defaultVariant.id;

    buildSupplyHeading();

    variants.forEach(function(variant) {
      var meta = VARIANT_META[variant.title] || { label: variant.title, sublabel: '', days: 365, isBestValue: false, image: '' };
      var isSelected = variant.id === defaultVariant.id;

      var card = document.createElement('div');
      card.className = 'ph2-card';
      card.setAttribute('data-variant-id', variant.id);
      card.setAttribute('data-variant-title', variant.title);
      card.style.cssText =
        'position:relative;border:1.5px solid ' + (isSelected ? COLOR_BORDER_BLUE : COLOR_GRAY_BORDER) + ';' +
        'border-radius:14px;padding:14px 16px;background:' + (isSelected ? COLOR_UPSELL_FILL : '#fff') + ';' +
        'display:flex;align-items:center;gap:14px;cursor:pointer;overflow:visible;' +
        'margin-top:' + (meta.isBestValue ? '14px' : '0') + ';margin-bottom:14px;';

      if (meta.isBestValue) {
        var ribbon = document.createElement('div');
        ribbon.className = 'ph2-best-ribbon';
        ribbon.style.cssText =
          'position:absolute;top:-10px;right:14px;background:' + COLOR_GREEN + ';color:#fff;' +
          'font-size:10.5px;font-weight:700;letter-spacing:0.03em;padding:4px 15px;border-radius:7px;';
        ribbon.textContent = 'BEST VALUE';
        card.appendChild(ribbon);
      }

      var img = document.createElement('img');
      img.className = 'ph2-card-img';
      img.src = meta.image;
      img.alt = meta.label;
      img.style.cssText = 'flex:0 0 auto;width:64px;height:64px;object-fit:contain;';
      card.appendChild(img);

      var midCol = document.createElement('div');
      midCol.style.cssText = 'flex:1 1 auto;min-width:0;';

      var titleRow = document.createElement('div');
      titleRow.className = 'ph2-card-titlerow';
      titleRow.style.cssText = 'display:flex;align-items:center;gap:7px;white-space:nowrap;';

      var labelEl = document.createElement('span');
      labelEl.className = 'ph2-card-label';
      labelEl.style.cssText = 'font-weight:700;font-size:16px;color:' + COLOR_NAVY + ';';
      labelEl.textContent = meta.label;
      titleRow.appendChild(labelEl);

      var pctPill = document.createElement('span');
      pctPill.className = 'ph2-pct-pill';
      if (meta.isBestValue) {
        pctPill.style.cssText = 'font-size:10.5px;font-weight:700;background:' + COLOR_GREEN + ';color:#fff;padding:2.5px 8px;border-radius:20px;display:none;';
      } else {
        pctPill.style.cssText = 'font-size:10.5px;font-weight:700;background:transparent;color:' + COLOR_GREEN + ';border:1.5px solid ' + COLOR_GREEN + ';padding:2px 7.5px;border-radius:20px;display:none;';
      }
      titleRow.appendChild(pctPill);
      midCol.appendChild(titleRow);

      var sublabelAndScarcity = document.createElement('div');
      sublabelAndScarcity.className = 'ph2-sublabel-table';
      sublabelAndScarcity.style.cssText = 'display:table;';

      var sublabelEl = document.createElement('div');
      sublabelEl.className = 'ph2-card-sublabel';
      sublabelEl.style.cssText = 'font-size:12.5px;color:' + COLOR_GRAY_TEXT + ';margin-top:3px;';
      sublabelEl.textContent = meta.sublabel;
      sublabelAndScarcity.appendChild(sublabelEl);

      var sublabelShortEl = document.createElement('div');
      sublabelShortEl.className = 'ph2-card-sublabel-short';
      sublabelShortEl.style.cssText = 'display:none;font-size:10.5px;color:' + COLOR_GRAY_TEXT + ';margin-top:2px;';
      sublabelShortEl.textContent = meta.sublabelShort;
      sublabelAndScarcity.appendChild(sublabelShortEl);

      var scarcityWrap = document.createElement('div');
      scarcityWrap.className = 'ph2-scarcity-wrap';
      scarcityWrap.style.cssText = 'margin-top:5px;width:100%;';

      var scarcityTrack = document.createElement('div');
      scarcityTrack.style.cssText = 'width:100%;height:5px;background:#b0b8cc;border-radius:20px;overflow:hidden;';
      var scarcityFill = document.createElement('div');
      scarcityFill.className = 'ph2-scarcity-bar-fill';
      scarcityFill.style.cssText = 'height:100%;border-radius:20px;width:0;transition:width 0.4s ease;';
      scarcityTrack.appendChild(scarcityFill);
      scarcityWrap.appendChild(scarcityTrack);

      var scarcityText = document.createElement('div');
      scarcityText.className = 'ph2-scarcity-text';
      scarcityText.style.cssText = 'font-size:10px;font-weight:700;margin-top:3px;';
      scarcityWrap.appendChild(scarcityText);

      sublabelAndScarcity.appendChild(scarcityWrap);
      midCol.appendChild(sublabelAndScarcity);
      card.appendChild(midCol);

      var rightCol = document.createElement('div');
      rightCol.className = 'ph2-card-rightcol';
      rightCol.style.cssText = 'flex:0 0 auto;text-align:right;';

      var comparePriceEl = document.createElement('div');
      comparePriceEl.className = 'ph2-card-compare';
      comparePriceEl.style.cssText = 'font-size:12px;color:#9ca3af;text-decoration:line-through;text-align:right;';
      rightCol.appendChild(comparePriceEl);

      var bigPriceEl = document.createElement('div');
      bigPriceEl.className = 'ph2-card-perday-main';
      bigPriceEl.style.cssText = 'font-size:20px;font-weight:800;color:' + COLOR_BLUE + ';line-height:1.1;text-align:right;';
      rightCol.appendChild(bigPriceEl);

      var billedEl = document.createElement('div');
      billedEl.className = 'ph2-card-billed';
      billedEl.style.cssText = 'font-size:11px;color:' + COLOR_GREEN + ';font-weight:700;margin-top:4px;text-align:right;';
      rightCol.appendChild(billedEl);

      card.appendChild(rightCol);

      var soldPill = document.createElement('span');
      soldPill.className = 'ph2-sold-pill';
      soldPill.textContent = 'SOLD OUT';
      soldPill.style.cssText = 'display:none;position:absolute;top:10px;right:10px;font-size:11px;font-weight:700;background:' + COLOR_NAVY + ';color:#fff;padding:4px 10px;border-radius:8px;';
      card.appendChild(soldPill);

      card.addEventListener('click', function() {
        if (!variant.available) return;
        state.currentVariantId = variant.id;
        highlightCard(variant.id, container);
        applyPricing();
      });

      container.appendChild(card);
    });

    highlightCard(defaultVariant.id, container);
    applyPricing();
  }

  function fetchUpsells(callback) {
    var results = [];
    var remaining = UPSELLS.length;
    if (remaining === 0) { callback([]); return; }

    UPSELLS.forEach(function(cfg, idx) {
      fetch('/products/' + encodeURIComponent(cfg.handle) + '.js')
        .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function(product) {
          var variant = (product.variants && product.variants[0]) || null;
          results[idx] = {
            handle: cfg.handle,
            name: cfg.name,
            shortName: cfg.shortName,
            blurb: cfg.blurb,
            image: cfg.image,
            variantId: variant ? variant.id : null,
            price: variant ? variant.price / 100 : null,
            comparePrice: variant && variant.compare_at_price ? variant.compare_at_price / 100 : null,
            available: variant ? variant.available !== false : false
          };
        })
        .catch(function(err) {
          console.error('[PH2] Could not load upsell ' + cfg.handle + ' \u2014', err);
          results[idx] = null;
        })
        .finally(function() {
          remaining -= 1;
          if (remaining === 0) callback(results.filter(Boolean));
        });
    });
  }

  function buildUpsells() {
    var container = document.getElementById('ph2-upsells');
    if (!container) return;

    fetchUpsells(function(items) {
      state.upsells = items;
      container.innerHTML = '';
      if (items.length === 0) return;

      var heading = document.createElement('div');
      heading.style.cssText = 'font-size:16px;font-weight:700;color:' + COLOR_BLACK + ';margin-bottom:10px;';
      heading.textContent = UPSELLS_HEADING;
      container.appendChild(heading);

      var grid = document.createElement('div');
      grid.style.cssText = 'display:grid;grid-template-columns:repeat(' + items.length + ',1fr);gap:8px;';

      items.forEach(function(item) {
        if (!item.variantId) return;

        var card = document.createElement('label');
        card.style.cssText =
          'position:relative;display:flex;flex-direction:column;border:1.5px dashed ' + COLOR_NAVY + ';' +
          'border-radius:10px;padding:8px;background:' + COLOR_UPSELL_FILL + ';cursor:pointer;';

        var checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.style.cssText = 'position:absolute;top:6px;left:6px;width:14px;height:14px;accent-color:' + COLOR_BORDER_BLUE + ';cursor:pointer;';
        checkbox.addEventListener('change', function() {
          state.selectedUpsells[item.handle] = checkbox.checked;
          updateUpsellSubtotal();
          updateAfterpay();
        });
        card.appendChild(checkbox);

        if (item.image) {
          var img = document.createElement('img');
          img.src = item.image;
          img.alt = item.name;
          img.style.cssText = 'width:100%;height:52px;object-fit:contain;margin-bottom:5px;';
          card.appendChild(img);
        }

        var nameEl = document.createElement('div');
        nameEl.style.cssText = 'font-size:11px;font-weight:700;color:' + COLOR_NAVY + ';line-height:1.2;';
        nameEl.textContent = item.shortName || item.name;
        card.appendChild(nameEl);

        var priceEl = document.createElement('div');
        priceEl.style.cssText = 'font-size:12px;font-weight:700;color:' + COLOR_NAVY + ';margin-top:4px;';
        priceEl.textContent = item.price !== null ? formatMoney(item.price, state.currency) : '';
        card.appendChild(priceEl);

        grid.appendChild(card);
      });

      container.appendChild(grid);

      var subtotal = document.createElement('div');
      subtotal.id = 'ph2-upsell-subtotal';
      subtotal.style.cssText = 'font-size:12px;color:' + COLOR_GRAY_TEXT + ';display:none;margin-top:8px;';
      container.appendChild(subtotal);
    });
  }

  function getSelectedUpsellTotal() {
    var total = 0;
    state.upsells.forEach(function(item) {
      if (state.selectedUpsells[item.handle] && item.price !== null) total += item.price;
    });
    return total;
  }

  function updateUpsellSubtotal() {
    var subtotalEl = document.getElementById('ph2-upsell-subtotal');
    if (!subtotalEl) return;
    var total = 0, count = 0;
    state.upsells.forEach(function(item) {
      if (state.selectedUpsells[item.handle] && item.price !== null) { total += item.price; count += 1; }
    });
    if (count > 0) {
      subtotalEl.textContent = '+ ' + formatMoney(total, state.currency) + ' added (' + count + ' item' + (count > 1 ? 's' : '') + ')';
      subtotalEl.style.display = '';
    } else {
      subtotalEl.style.display = 'none';
    }
  }

  function getSelectedUpsellLineItems() {
    var items = [];
    state.upsells.forEach(function(item) {
      if (state.selectedUpsells[item.handle] && item.variantId && item.available) {
        items.push({ id: item.variantId, quantity: 1 });
      }
    });
    return items;
  }

  function updateAfterpay() {
    var variant = getCurrentVariant();
    if (!variant) return;
    var apSupported = AFTERPAY_CURRENCIES.indexOf(state.currency) !== -1;
    var total = variant.price + getSelectedUpsellTotal();

    var apStrip  = document.getElementById('ph2-afterpay');
    var apAmount = document.getElementById('ph2-afterpay-amount');
    if (apStrip && apAmount) {
      if (apSupported) {
        apAmount.textContent = formatMoney(total / 4, state.currency);
        apStrip.style.display = '';
      } else {
        apStrip.style.display = 'none';
      }
    }

    var apTopAmt   = document.getElementById('ph2-ap-top-amount');
    var apTopTotal = document.getElementById('ph2-ap-top-total');
    var apTopBlock = document.getElementById('ph2-ap-top');
    if (apTopBlock) {
      if (apSupported) {
        if (apTopAmt)   apTopAmt.textContent   = formatMoney(total / 4, state.currency);
        if (apTopTotal) apTopTotal.textContent  = formatMoneyNoDecimal(total, state.currency) + ' total';
        apTopBlock.style.display = '';
      } else {
        apTopBlock.style.display = 'none';
      }
    }
  }

  function buildCtaSection() {
    var container = document.getElementById('ph2-cta');
    if (!container) { console.warn('[PH2] No #ph2-cta container found.'); return; }
    container.innerHTML = '';
    container.style.cssText = 'margin-top:16px;';

    var atcBtn = document.createElement('button');
    atcBtn.type = 'button';
    atcBtn.id = 'ph2-atc-btn';
    atcBtn.style.cssText =
      'display:flex;align-items:center;justify-content:center;width:100%;' +
      'background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:16px;text-align:center;' +
      'border:none;border-radius:10px;cursor:pointer;padding:14px 16px;margin-bottom:8px;';
    atcBtn.textContent = 'Add to cart';
    atcBtn.addEventListener('click', handleAddToCartClick);
    container.appendChild(atcBtn);

    var buyBtn = document.createElement('span');
    buyBtn.id = 'ph2-buy-btn';
    buyBtn.style.cssText = 'display:none;';
    container.appendChild(buyBtn);

    var apStrip = document.createElement('div');
    apStrip.id = 'ph2-afterpay';
    apStrip.style.cssText =
      'display:flex;flex-wrap:nowrap;justify-content:center;align-items:center;' +
      'text-align:center;white-space:nowrap;font-size:0.85rem;color:' + COLOR_GRAY_TEXT + ';margin-top:10px;';
    apStrip.innerHTML =
      '<span style="white-space:nowrap;">or 4 payments of <strong id="ph2-afterpay-amount" style="color:' + COLOR_BLACK + ';"></strong> with</span>' +
      '<img src="' + AFTERPAY_LOGO_URL + '" alt="Afterpay" style="height:14px;width:auto;display:inline-block;flex-shrink:0;vertical-align:middle;margin-left:6px;" />';
    container.appendChild(apStrip);

    var badgesRow = document.createElement('div');
    badgesRow.style.cssText = 'display:flex;justify-content:space-between;gap:8px;margin-top:20px;';
    var TRUST_BADGES = [
      { label: 'Free Shipping',      svg: '<rect x="1" y="6" width="13" height="10"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>' },
      { label: 'Free Returns',       svg: '<path d="M3 12a9 9 0 1 0 3-6.7"/><polyline points="3 4 3 9 8 9"/>' },
      { label: '100 Day Money Back', svg: '<path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z"/><polyline points="9 12 11 14 15 10"/>' }
    ];
    TRUST_BADGES.forEach(function(badge) {
      var col = document.createElement('div');
      col.style.cssText = 'display:flex;flex-direction:column;align-items:center;flex:1 1 0;text-align:center;';
      var iconBox = document.createElement('div');
      iconBox.style.cssText = 'width:48px;height:48px;border:1.5px solid ' + COLOR_GRAY_BORDER + ';border-radius:10px;display:flex;align-items:center;justify-content:center;margin-bottom:8px;color:' + COLOR_BLUE + ';';
      iconBox.innerHTML = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + badge.svg + '</svg>';
      col.appendChild(iconBox);
      var labelEl = document.createElement('div');
      labelEl.style.cssText = 'font-size:12px;font-weight:700;color:' + COLOR_BLUE + ';line-height:1.25;';
      labelEl.textContent = badge.label;
      col.appendChild(labelEl);
      badgesRow.appendChild(col);
    });
    container.appendChild(badgesRow);

    // Stock scarcity banner
    var stockBanner = document.createElement('div');
    stockBanner.style.cssText = [
      'margin-top:14px;',
      'border:1.5px dashed #ef4444;',
      'border-radius:12px;',
      'padding:11px 14px;',
      'background:#fff5f5;',
      'text-align:center;',
      'font-size:13px;',
      'line-height:1.5;',
      'color:#b91c1c;'
    ].join('');
    stockBanner.innerHTML = '<strong>STOCK UPDATE</strong> — Due to recent sales spikes, inventory is running low. Secure yours today.';
    container.appendChild(stockBanner);
  }

  function tryOpenCartDrawer() {
    try { document.dispatchEvent(new CustomEvent('cart:build')); } catch (e) {}
    return fetch('/?section_id=cart-drawer')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer    = doc.querySelector('cart-drawer');
        var existingDrawer = document.querySelector('cart-drawer');
        if (!freshDrawer || !existingDrawer) return false;
        existingDrawer.outerHTML = freshDrawer.outerHTML;
        var newDrawer = document.querySelector('cart-drawer');
        if (!newDrawer) return false;
        if (typeof newDrawer.open === 'function') newDrawer.open();
        else if (typeof newDrawer.show === 'function') newDrawer.show();
        else { newDrawer.setAttribute('open', ''); newDrawer.classList.add('is-open', 'active', 'drawer--open'); }
        return true;
      })
      .catch(function(err) {
        console.error('[PH2] Cart drawer refresh failed \u2014', err);
        var iconCandidates = ['#CartDrawer-Toggle', '.js-drawer-open-cart', '#cart-icon-bubble', '.site-header__cart', 'a.site-header__icon--cart', '.header__icon--cart', '[data-cart-icon]'];
        for (var j = 0; j < iconCandidates.length; j++) {
          var icon = document.querySelector(iconCandidates[j]);
          if (icon) { icon.click(); return true; }
        }
        return false;
      });
  }

  function performAddToCart() {
    var variant = getCurrentVariant();
    if (!variant) return Promise.reject(new Error('No variant selected'));
    var items = [{ id: variant.id, quantity: state.quantity }].concat(getSelectedUpsellLineItems());
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(result) {
        try { document.dispatchEvent(new CustomEvent('cart:updated')); } catch (e) {}
        return tryOpenCartDrawer().then(function(opened) {
          if (!opened) window.location.href = POST_ADD_REDIRECT;
          return result;
        });
      });
  }

  function handleAddToCartClick() {
    var atcBtn = document.getElementById('ph2-atc-btn');
    var originalText = atcBtn.textContent;
    atcBtn.disabled = true;
    atcBtn.style.opacity = '0.7';
    atcBtn.textContent = 'Adding...';
    performAddToCart()
      .then(function() {
        atcBtn.disabled = false;
        atcBtn.style.opacity = '';
        atcBtn.textContent = originalText;
      })
      .catch(function(err) {
        console.error('[PH2] Add to cart failed \u2014', err);
        atcBtn.disabled = false;
        atcBtn.style.opacity = '';
        atcBtn.textContent = originalText;
        alert('Something went wrong adding this to your cart \u2014 please try again.');
      });
  }

  function handleBuyClick() {
    var buyBtn = document.getElementById('ph2-buy-btn');
    var originalText = buyBtn.textContent;
    buyBtn.disabled = true;
    buyBtn.style.opacity = '0.7';
    buyBtn.textContent = 'Going to checkout...';
    var variant = getCurrentVariant();
    if (!variant) return;
    var items = [{ id: variant.id, quantity: state.quantity }].concat(getSelectedUpsellLineItems());
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
    .then(function() { window.location.href = '/checkout'; })
    .catch(function(err) {
      console.error('[PH2] Buy now failed \u2014', err);
      buyBtn.disabled = false;
      buyBtn.style.opacity = '';
      buyBtn.textContent = originalText;
      alert('Something went wrong \u2014 please try again.');
    });
  }

  function openSimpleModal(title, bodyHtml) {
    var existing = document.getElementById('ph2-modal');
    if (existing) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.id = 'ph2-modal';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(17,24,39,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;';

    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:14px;width:100%;max-width:600px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;';

    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';flex-shrink:0;';
    var titleEl = document.createElement('div');
    titleEl.style.cssText = 'font-size:16px;font-weight:700;color:' + COLOR_NAVY + ';';
    titleEl.textContent = title;
    header.appendChild(titleEl);
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = '\u2715';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = 'border:none;background:none;font-size:18px;color:' + COLOR_GRAY_TEXT + ';cursor:pointer;padding:4px 8px;';
    closeBtn.addEventListener('click', function() { modal.parentNode.removeChild(modal); });
    header.appendChild(closeBtn);
    box.appendChild(header);

    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;';
    body.innerHTML = bodyHtml;
    box.appendChild(body);

    modal.appendChild(box);
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.parentNode.removeChild(modal); });
    document.body.appendChild(modal);
    return body;
  }

  function openVideoModal(youtubeId) {
    var existing = document.getElementById('ph2-modal');
    if (existing) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.id = 'ph2-modal';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(17,24,39,0.85);z-index:9999;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box;';

    var box = document.createElement('div');
    box.style.cssText = 'position:relative;width:100%;max-width:640px;';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = '\u2715';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = 'position:absolute;top:-44px;right:0;width:32px;height:32px;border-radius:50%;background:#fff;border:none;color:' + COLOR_NAVY + ';font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;';
    closeBtn.addEventListener('click', function() { modal.parentNode.removeChild(modal); });
    box.appendChild(closeBtn);

    var playerWrap = document.createElement('div');
    playerWrap.style.cssText = 'position:relative;width:100%;aspect-ratio:16/9;border-radius:12px;overflow:hidden;background:#000;';
    playerWrap.innerHTML = '<iframe width="100%" height="100%" style="position:absolute;top:0;left:0;border:0;" src="https://www.youtube.com/embed/' + youtubeId + '?autoplay=1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
    box.appendChild(playerWrap);

    modal.appendChild(box);
    modal.addEventListener('click', function(e) { if (e.target === modal) modal.parentNode.removeChild(modal); });
    document.body.appendChild(modal);
  }

  var LAB_TEST_PDF_URL = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/PuraHome.pdf?v=1781945780';

  function openLabTestPopup() {
    var existing = document.getElementById('ph2-modal');
    if (existing) existing.parentNode.removeChild(existing);

    var modal = document.createElement('div');
    modal.id = 'ph2-modal';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:#f9fafb;z-index:99999;display:flex;flex-direction:column;overflow:hidden;box-sizing:border-box;';

    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 16px;background:#fff;border-bottom:1px solid #e5e7eb;flex-shrink:0;position:sticky;top:0;z-index:10;box-shadow:0 1px 4px rgba(0,0,0,0.06);';

    var titleEl = document.createElement('div');
    titleEl.style.cssText = 'font-size:15px;font-weight:700;color:' + COLOR_NAVY + ';';
    titleEl.textContent = 'Independent Lab Results';
    header.appendChild(titleEl);

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.innerHTML = '\u2715';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.style.cssText = 'border:none;background:#f3f4f6;border-radius:50%;width:32px;height:32px;font-size:14px;color:#6b7280;cursor:pointer;flex-shrink:0;display:flex;align-items:center;justify-content:center;-webkit-tap-highlight-color:transparent;';
    closeBtn.addEventListener('click', function() { document.body.style.overflow = ''; document.body.removeChild(modal); });
    header.appendChild(closeBtn);
    modal.appendChild(header);

    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;padding:16px;max-width:700px;width:100%;margin:0 auto;box-sizing:border-box;';

    var heroHtml = '<div style="text-align:center;margin-bottom:18px;"><div style="font-size:20px;font-weight:800;color:#111827;margin-bottom:6px;line-height:1.3;">Independent lab testing.<br>Real results.</div><div style="font-size:13px;color:#6b7280;line-height:1.5;">Water purified by PuraHome, tested by an accredited third-party laboratory.</div></div>';

    var statsHtml = '<div style="display:grid;grid-template-columns:repeat(4,1fr);gap:8px;margin-bottom:14px;">';
    [{num:'14',lbl:'Parameters tested'},{num:'14/14',lbl:'Passed'},{num:'CMA',lbl:'Accredited lab'},{num:'2029',lbl:'Valid until'}].forEach(function(s) {
      statsHtml += '<div style="background:#fff;border-radius:10px;padding:10px 6px;text-align:center;border:1px solid #e5e7eb;"><div style="font-size:16px;font-weight:700;color:' + COLOR_BLUE + ';">' + s.num + '</div><div style="font-size:10px;color:#6b7280;margin-top:2px;line-height:1.3;">' + s.lbl + '</div></div>';
    });
    statsHtml += '</div>';

    var certHtml = '<div style="background:#f0fdf4;border-radius:10px;padding:10px 12px;display:flex;gap:8px;align-items:flex-start;margin-bottom:14px;"><span style="font-size:16px;flex-shrink:0;">\u2705</span><div style="font-size:11px;color:#166534;line-height:1.6;"><strong>CMA Accredited \u2014 Report No. XYS202500786</strong><br>Henan TaiQing Quality Testing Co., LTD \u00b7 CMA No. 231600140601 \u00b7 Valid until Nov 7, 2029 \u00b7 Tested June 2025 \u00b7 GB 5749-2022 standard.</div></div>';
    var noteHtml = '<div style="background:#eff6ff;border-left:3px solid ' + COLOR_BLUE + ';padding:9px 12px;font-size:11px;color:#374151;line-height:1.6;margin-bottom:16px;border-radius:0 8px 8px 0;"><strong>"Not detected"</strong> means the contaminant fell below the instrument\'s detection threshold \u2014 the most sensitive measurement available. These are not estimates.</div>';
    var sectionLabelHtml = '<div style="font-size:10px;font-weight:700;color:#9ca3af;text-transform:uppercase;letter-spacing:0.08em;margin-bottom:10px;">Results by contaminant category</div>';

    function nd(sub) { return '<span style="display:inline-block;background:#eff6ff;color:' + COLOR_BLUE + ';font-size:11px;font-weight:600;padding:2px 7px;border-radius:20px;white-space:nowrap;">Not detected</span>' + (sub ? '<div style="font-size:10px;color:#9ca3af;margin-top:2px;">' + sub + '</div>' : ''); }
    function pass(val, sub) { return '<span style="display:inline-block;background:#f0fdf4;color:#16a34a;font-size:11px;font-weight:600;padding:2px 7px;border-radius:20px;white-space:nowrap;">' + val + '</span>' + (sub ? '<div style="font-size:10px;color:#9ca3af;margin-top:2px;">' + sub + '</div>' : ''); }
    function conf() { return '<span style="display:inline-block;background:#f0fdf4;color:#16a34a;font-size:11px;font-weight:600;padding:2px 7px;border-radius:20px;">\u2713 Pass</span>'; }
    function pct(val, cite) { return '<span style="display:inline-block;font-size:13px;font-weight:700;color:#16a34a;">' + val + '</span>' + (cite ? '<div style="font-size:10px;color:#9ca3af;margin-top:2px;line-height:1.3;">' + cite + '</div>' : ''); }
    function red(t) { return '<span style="font-size:11px;color:#dc2626;line-height:1.4;">' + t + '</span>'; }
    function grey(t) { return '<span style="font-size:11px;color:#6b7280;">' + t + '</span>'; }
    function dash() { return '<span style="font-size:13px;color:#9ca3af;">\u2014</span>'; }

    function makeTable(rows) {
      var th = function(t, w) { return '<th style="text-align:left;padding:6px 6px;color:#9ca3af;font-weight:500;font-size:10px;border-bottom:1px solid #e5e7eb;white-space:nowrap;' + (w ? 'width:' + w + ';' : '') + '">' + t + '</th>'; };
      var h = '<div style="overflow-x:auto;-webkit-overflow-scrolling:touch;"><table style="width:100%;border-collapse:collapse;font-size:12px;min-width:420px;"><thead><tr>' + th('Contaminant','22%') + th('Lab result','22%') + th('Health concern','24%') + th('Media removal','20%') + th('Verdict','12%') + '</tr></thead><tbody>';
      rows.forEach(function(r) { h += '<tr><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;font-weight:600;color:#111827;font-size:12px;vertical-align:top;">' + r[0] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[1] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[2] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[3] + '</td><td style="padding:8px 6px;border-bottom:1px solid #f3f4f6;vertical-align:top;">' + r[4] + '</td></tr>'; });
      h += '</tbody></table></div>';
      return h;
    }

    var sections = [
      { icon: '\u2697\ufe0f', title: 'Heavy metals', open: true, badge: null, sub: 'Lead, mercury, arsenic, cadmium, chromium, iron, manganese', note: '<strong>Filtration media:</strong> Activated carbon block + KDF copper-zinc alloy. KDF operates via electrochemical redox \u2014 heavy metals are rendered insoluble and trapped within the media matrix. <strong>Published research:</strong> Ott et al. (2000) demonstrated KDF media achieving 95\u201399% lead reduction in controlled flow-through conditions.', rows: [['Lead',nd('<0.07 \u00b5g/L'),red('Brain and nervous system damage'),pct('95\u201399%','KDF / carbon block (NSF/ANSI 53)'),conf()],['Mercury',nd('<0.1 \u00b5g/L'),red('Neurological damage'),pct('95\u201399%','KDF redox reaction (Ott et al., 2000)'),conf()],['Arsenic',pass('0.00053 mg/L','Limit: \u22640.01 mg/L'),red('Cancer'),pct('~98%','Activated carbon + KDF (Water Research, 2018)'),conf()],['Cadmium',nd('<0.06 \u00b5g/L'),red('Bone density and kidney damage'),pct('95\u201399%','KDF / carbon block (NSF/ANSI 53)'),conf()],['Chromium (hex)',nd('<0.004 mg/L'),red('Cancer'),pct('95\u201399%','KDF redox (Crittenden et al., 2012)'),conf()],['Iron',nd('<4.5 \u00b5g/L'),grey('Organ stress at high levels'),pct('>99%','Mechanical + KDF'),conf()],['Manganese',pass('0.00070 mg/L','Limit: \u22640.1 mg/L'),red('Cognitive effects'),pct('95\u201399%','KDF oxidation-reduction (Crittenden et al., 2012)'),conf()]] },
      { icon: '\ud83d\udca7', title: 'Chemical disinfectants & fluoride', open: false, badge: null, sub: 'Chlorine, fluoride, odour, taste', note: '<strong>Filtration media:</strong> Coconut shell activated carbon (CTO grade). Activated carbon adsorption is globally recognised as best-available technology for chlorine removal. <strong>Published research:</strong> WHO Guidelines for Drinking-water Quality (4th ed., 2022) confirm activated carbon achieves 98\u201399% chlorine reduction.', rows: [['Chlorine (free)',pass('0.01 mg/L','Very low residual'),red('Cancer-linked disinfection byproducts'),pct('98\u201399%','Activated carbon CTO (WHO, 2022)'),grey('Data recorded')],['Fluoride',nd('<0.1 mg/L'),red('Dental and skeletal fluorosis'),pct('90\u201398%','Mineral adsorption media (Water Research, 2023)'),conf()],['Odour & taste',nd('None detected'),grey('Quality indicator'),pct('98\u201399%','Coconut shell carbon (NSF/ANSI 42)'),conf()]] },
      { icon: '\ud83e\udda0', title: 'Bacteria & microorganisms', open: false, badge: null, sub: 'E. coli, total colony count', note: '<strong>Filtration media:</strong> KDF media is bacteriostatic \u2014 it inhibits bacterial growth within the filter. <strong>Published research:</strong> KDF media confirmed to inhibit growth of E. coli and Pseudomonas (Ott et al., 2000; Silver et al., 1999).', rows: [['E. coli',nd(''),red('Severe gastrointestinal illness'),pct('>99%','KDF bacteriostatic action (Ott et al., 2000)'),conf()],['Total colony count',nd('Limit: \u2264100 CFU/mL'),red('General microbial contamination'),pct('>99%','Multi-barrier filtration (WHO, 2022)'),conf()]] },
      { icon: '\ud83d\udd2c', title: 'Physical properties', open: false, badge: null, sub: 'Turbidity, visible particles', note: '<strong>Filtration media:</strong> Non-woven mechanical pre-filter acts as a physical size-exclusion barrier, blocking sediment, rust, and visible particles.', rows: [['Turbidity',pass('<1 NTU','Limit: \u22641 NTU'),grey('Sediment and particle load indicator'),pct('90\u201399%','Mechanical pre-filtration (NSF/ANSI 42)'),conf()],['Visible particles',nd('None detected'),grey('Quality indicator'),pct('>99%','Size-exclusion mechanical filter'),conf()]] },
      { icon: '\ud83e\uddea', title: 'PFAS & microplastics', open: false, badge: null, sub: 'PFOA \u00b7 PFOS \u00b7 PFAS compounds \u00b7 microplastic particles', note: '<strong>Filtration media:</strong> Activated carbon block (ACB) is the primary PFAS-reduction media, confirmed effective via size exclusion and adsorption. Microplastic removal via mechanical pre-filtration and carbon block pore structure. <strong>Published research:</strong> Activated carbon block shown to reduce PFOA/PFOS by 73\u201399% depending on influent concentration (Appleman et al., 2014; Dickenson & Higgins, 2016). NSF/ANSI 53 & 58 certify ACB filters for PFAS reduction. Microplastic removal via ACB confirmed at >95% for particles >1\u00b5m (Zuccarini et al., 2023).', rows: [['PFOA',dash(),red('Cancer, hormone disruption, immune suppression'),pct('73\u201399%','Activated carbon block (Appleman et al., 2014)'),dash()],['PFOS',dash(),red('Cancer, thyroid disruption, developmental harm'),pct('73\u201399%','Activated carbon block (Dickenson & Higgins, 2016)'),dash()],['PFAS (total)',dash(),red('Forever chemicals \u2014 accumulate in blood and organs'),pct('Up to 99%','NSF/ANSI 53 & 58 certified ACB filters'),dash()],['Microplastics',dash(),red('Inflammatory response, endocrine disruption'),pct('>95%','ACB mechanical + adsorption (Zuccarini et al., 2023)'),dash()]] }
    ];

    var accordionHtml = '';
    sections.forEach(function(s, idx) {
      var bodyId = 'ph2-acc-body-' + idx;
      var chevId = 'ph2-acc-chev-' + idx;
      var badgeHtml = s.badge === null && s.title.indexOf('PFAS') !== -1
        ? '<span style="font-size:13px;color:#9ca3af;">—</span>'
        : s.badge
          ? '<span style="background:#fefce8;color:#854d0e;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px;white-space:nowrap;">' + s.badge + '</span>'
          : '<span style="background:#f0fdf4;color:#16a34a;font-size:10px;font-weight:700;padding:3px 9px;border-radius:20px;white-space:nowrap;">All conforming</span>';
      accordionHtml += '<div style="border:1px solid #e5e7eb;border-radius:12px;margin-bottom:10px;overflow:hidden;"><div data-ph2-acc="' + idx + '" style="display:flex;align-items:center;justify-content:space-between;padding:12px 14px;background:#fff;cursor:pointer;-webkit-tap-highlight-color:transparent;user-select:none;"><div style="display:flex;align-items:center;gap:10px;"><span style="font-size:18px;flex-shrink:0;">' + s.icon + '</span><div><div style="font-size:13px;font-weight:700;color:#111827;">' + s.title + '</div><div style="font-size:10px;color:#9ca3af;margin-top:2px;line-height:1.3;">' + s.sub + '</div></div></div><div style="display:flex;align-items:center;gap:8px;flex-shrink:0;">' + badgeHtml + '<span id="' + chevId + '" style="font-size:20px;color:#9ca3af;font-weight:300;width:20px;text-align:center;line-height:1;">' + (s.open ? '-' : '+') + '</span></div></div><div id="' + bodyId + '" style="display:' + (s.open ? 'block' : 'none') + ';border-top:1px solid #e5e7eb;"><div style="background:#f8fafc;padding:10px 14px;font-size:11px;color:#374151;line-height:1.7;border-bottom:1px solid #e5e7eb;">' + s.note + '</div>' + makeTable(s.rows) + '</div></div>';
    });

    var footerHtml = '<div style="text-align:center;padding:20px 0 16px;font-size:11px;color:#9ca3af;line-height:1.8;">All lab results from independent third-party testing, June 2025.<br>Media removal percentages cited from published peer-reviewed research on filtration technology.<br><br><a href="' + LAB_TEST_PDF_URL + '" target="_blank" rel="noopener" style="color:' + COLOR_BLUE + ';font-weight:600;font-size:12px;text-decoration:none;">View full lab certificate PDF \u2014 Report No. XYS202500786 \u2197</a></div>';

    body.innerHTML = heroHtml + statsHtml + certHtml + noteHtml + sectionLabelHtml + accordionHtml + footerHtml;

    body.addEventListener('click', function(e) {
      var hdr = e.target.closest('[data-ph2-acc]');
      if (!hdr) return;
      var idx = hdr.getAttribute('data-ph2-acc');
      var b = document.getElementById('ph2-acc-body-' + idx);
      var c = document.getElementById('ph2-acc-chev-' + idx);
      if (!b) return;
      var isOpen = b.style.display !== 'none';
      b.style.display = isOpen ? 'none' : 'block';
      if (c) c.textContent = isOpen ? '+' : '-';
    });

    modal.appendChild(body);
    document.body.style.overflow = 'hidden';
    document.body.appendChild(modal);
  }

  var FAQ_ITEMS = [
    { type: 'founder', q: 'Us vs The Alternatives', open: true },
    { type: 'popup',  q: 'Will it fit my tap?', a: 'PuraHome is designed to fit the vast majority of standard kitchen taps, and ships with multiple adapters to cover less common fittings. Not sure about yours?', linkText: 'Take our Tap Fit Quiz', popupHandler: function() { openQuizPopup(); } },


    { type: 'popup',  q: 'Is this NSF certified?', a: 'Yes \u2014 PuraHome is NSF certified, independently verified to reduce contaminants to international water quality standards. NSF International is one of the world\'s most rigorous third-party testing and certification bodies, recognised by health authorities globally.', linkText: 'View NSF Certificate', popupHandler: function() { openNSFCertPopup(); } },
    { type: 'text',   q: 'What about shipping and your guarantee?', a: 'Every order ships free, no minimum spend required. You\'re also covered by our 100-night risk-free trial \u2014 if you\'re not happy, reach out within that window for a full refund.' },
    { type: 'popup',  q: 'Find out how toxic your water is \u2192', a: 'Answer 5 quick questions about your home and water source and we\'ll calculate your personalised Toxic Water Score \u2014 plus send you a full breakdown and a discount code.', linkText: 'Take the quiz (60 seconds)', popupHandler: function() { var btn = document.getElementById('pwhq-open'); if (btn) btn.click(); } }
  ];

  var TAP_QUIZ_OPTIONS = [
    { image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260620_080517_133beb2e-af20-4f37-93f2-9980357bae8d.png?v=1781942816', label: 'Pull-out spray tap', compatible: false },
    { image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260620_080600_cd52ed7c-b0a7-4a3e-987e-4d5177b0b25a.png?v=1781942834', label: 'Sensor / touchless tap', compatible: false },
    { image: 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260620_080659_df4f57bf-faaf-46c9-9de1-057b24983ff4.png?v=1781942856', label: 'Built-in aerator tap', compatible: false },
    { emoji: '\u2705', label: 'None of these \u2014 my tap is different', compatible: true }
  ];

  function renderQuizQuestion(body) {
    body.innerHTML = '<div style="padding:18px;"><div style="font-size:18px;font-weight:800;color:' + COLOR_NAVY + ';margin-bottom:16px;line-height:1.3;">Does your tap have any of these features?</div><div id="ph2-quiz-grid" style="display:grid;grid-template-columns:1fr 1fr;gap:10px;"></div></div>';
    var grid = body.querySelector('#ph2-quiz-grid');
    TAP_QUIZ_OPTIONS.forEach(function(opt) {
      var card = document.createElement('button');
      card.type = 'button';
      card.style.cssText = 'display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;border:1.5px solid ' + COLOR_GRAY_BORDER + ';border-radius:12px;padding:14px 10px;background:#fff;cursor:pointer;text-align:center;min-height:110px;';
      if (opt.image) { var imgEl = document.createElement('img'); imgEl.src = opt.image; imgEl.alt = opt.label; imgEl.style.cssText = 'width:60px;height:60px;object-fit:contain;'; card.appendChild(imgEl); }
      else if (opt.emoji) { var emojiEl = document.createElement('div'); emojiEl.style.cssText = 'font-size:32px;line-height:1;'; emojiEl.textContent = opt.emoji; card.appendChild(emojiEl); }
      var labelEl = document.createElement('div'); labelEl.style.cssText = 'font-size:13px;font-weight:700;color:' + COLOR_NAVY + ';line-height:1.3;'; labelEl.textContent = opt.label; card.appendChild(labelEl);
      card.addEventListener('click', function() { opt.compatible ? renderQuizResultCompatible(body) : renderQuizResultIncompatible(body); });
      grid.appendChild(card);
    });
  }

  function renderQuizResultCompatible(body) {
    body.innerHTML = '<div style="padding:18px;"><div style="width:40px;height:40px;border-radius:10px;background:' + COLOR_GREEN + ';color:#fff;display:flex;align-items:center;justify-content:center;font-size:20px;font-weight:800;margin-bottom:14px;">\u2713</div><div style="font-size:19px;font-weight:800;color:' + COLOR_NAVY + ';margin-bottom:10px;line-height:1.3;">Great news \u2014 your tap is compatible!</div><div style="font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.6;margin-bottom:18px;">Based on your answer, PuraHome fits your tap. You\'ll enjoy cleaner, better-tasting water directly from your faucet \u2014 no tools, no plumber needed.</div><button type="button" id="ph2-quiz-done-btn" style="background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:14px;border:none;border-radius:10px;padding:12px 20px;cursor:pointer;">Got It</button> <a href="#" id="ph2-quiz-restart-1" style="font-size:13px;color:' + COLOR_GRAY_TEXT + ';text-decoration:underline;margin-left:14px;">Restart quiz</a></div>';
    body.querySelector('#ph2-quiz-done-btn').addEventListener('click', function() { var m = document.getElementById('ph2-modal'); if (m) m.parentNode.removeChild(m); });
    body.querySelector('#ph2-quiz-restart-1').addEventListener('click', function(e) { e.preventDefault(); renderQuizQuestion(body); });
  }

  function renderQuizResultIncompatible(body) {
    body.innerHTML = '<div style="padding:18px;"><div style="width:40px;height:40px;border-radius:10px;background:#dc2626;color:#fff;display:flex;align-items:center;justify-content:center;font-size:18px;font-weight:800;margin-bottom:14px;">\u2715</div><div style="font-size:19px;font-weight:800;color:' + COLOR_NAVY + ';margin-bottom:10px;line-height:1.3;">Sadly, your tap isn\'t compatible</div><div style="font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.6;margin-bottom:18px;">PuraHome isn\'t designed to fit this tap style out of the box. Reach out to our support team and we\'ll help you find the right fit.</div><a href="https://mypurahome.com/pages/contact" target="_blank" rel="noopener" style="display:inline-block;background:' + COLOR_BLUE + ';color:#fff;font-weight:700;font-size:14px;border-radius:10px;padding:12px 20px;text-decoration:none;">Contact Support</a> <a href="#" id="ph2-quiz-restart-2" style="font-size:13px;color:' + COLOR_GRAY_TEXT + ';text-decoration:underline;margin-left:14px;">Restart quiz</a></div>';
    body.querySelector('#ph2-quiz-restart-2').addEventListener('click', function(e) { e.preventDefault(); renderQuizQuestion(body); });
  }

  function openQuizPopup() {
    var body = openSimpleModal('Will It Fit My Tap?', '');
    renderQuizQuestion(body);
  }

  function openNSFCertPopup() {
    var existing = document.getElementById('ph2-modal');
    if (existing) existing.parentNode.removeChild(existing);
    var modal = document.createElement('div');
    modal.id = 'ph2-modal';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(17,24,39,0.6);z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px;box-sizing:border-box;';
    var box = document.createElement('div');
    box.style.cssText = 'background:#fff;border-radius:14px;width:100%;max-width:680px;max-height:90vh;display:flex;flex-direction:column;overflow:hidden;';
    var header = document.createElement('div');
    header.style.cssText = 'display:flex;justify-content:space-between;align-items:center;padding:14px 18px;border-bottom:1px solid #d8dce3;flex-shrink:0;';
    var titleEl = document.createElement('div');
    titleEl.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:16px;font-weight:700;color:' + COLOR_NAVY + ';';
    titleEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#01b778" stroke="#01b778" stroke-width="1.5" stroke-linejoin="round"/></svg>NSF Certification';
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.textContent = '\u2715';
    closeBtn.style.cssText = 'border:none;background:none;font-size:20px;color:' + COLOR_GRAY_TEXT + ';cursor:pointer;padding:4px 8px;';
    closeBtn.addEventListener('click', function() { document.body.removeChild(modal); });
    header.appendChild(titleEl);
    header.appendChild(closeBtn);
    box.appendChild(header);
    var body = document.createElement('div');
    body.style.cssText = 'flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;';
    var img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/PDP_-_tap_water_filter_2.0_800_x_600_px_1.png?v=1776994202';
    img.alt = 'NSF Certification';
    img.style.cssText = 'width:100%;display:block;';
    body.appendChild(img);
    box.appendChild(body);
    modal.appendChild(box);
    modal.addEventListener('click', function(e) { if (e.target === modal) document.body.removeChild(modal); });
    document.body.appendChild(modal);
  }

  window.openPuraLabTest = openLabTestPopup;

  function buildFAQ() {
    var container = document.getElementById('ph2-faq');
    if (!container) { console.warn('[PH2] No #ph2-faq container found \u2014 FAQ section skipped.'); return; }
    container.innerHTML = '';
    var allRows = [];
    FAQ_ITEMS.forEach(function(item) {
      var row = document.createElement('div');
      row.style.cssText = 'border-bottom:1px solid ' + COLOR_GRAY_BORDER + ';padding:13px 0;';
      var qRow = document.createElement('div');
      qRow.style.cssText = 'display:flex;justify-content:space-between;align-items:center;gap:12px;cursor:pointer;';
      var qText = document.createElement('div');
      qText.style.cssText = 'font-size:14px;font-weight:700;color:' + COLOR_NAVY + ';';
      qText.textContent = item.q;
      qRow.appendChild(qText);
      var toggleIcon = document.createElement('div');
      toggleIcon.style.cssText = 'flex:0 0 auto;font-size:17px;font-weight:700;color:' + COLOR_BLUE + ';transition:transform 0.2s ease;';
      toggleIcon.textContent = '+';
      qRow.appendChild(toggleIcon);
      row.appendChild(qRow);
      var aWrap = document.createElement('div');
      aWrap.style.cssText = 'max-height:0;overflow:hidden;transition:max-height 0.3s ease, margin-top 0.25s ease;';
      var aInner = document.createElement('div');
      if (item.type === 'text') {
        var aText = document.createElement('div');
        aText.style.cssText = 'font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.5;';
        aText.textContent = item.a;
        aInner.appendChild(aText);
      } else if (item.type === 'popup') {
        var popupText = document.createElement('div');
        popupText.style.cssText = 'font-size:14px;color:' + COLOR_GRAY_TEXT + ';line-height:1.5;margin-bottom:10px;';
        popupText.textContent = item.a;
        aInner.appendChild(popupText);
        var popupBtn = document.createElement('button');
        popupBtn.type = 'button';
        popupBtn.textContent = item.linkText;
        popupBtn.style.cssText = 'font-size:13px;font-weight:700;color:#fff;background:' + COLOR_BLUE + ';padding:8px 16px;border-radius:8px;border:none;cursor:pointer;';
        popupBtn.addEventListener('click', function() { item.popupHandler(); });
        aInner.appendChild(popupBtn);
      } else if (item.type === 'video') {
        var videoCard = document.createElement('div');
        videoCard.style.cssText = 'position:relative;width:100%;aspect-ratio:16/9;border-radius:10px;overflow:hidden;cursor:pointer;background:#000;';
        var thumb = document.createElement('img');
        thumb.src = 'https://img.youtube.com/vi/' + item.youtubeId + '/hqdefault.jpg';
        thumb.alt = item.q;
        thumb.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
        videoCard.appendChild(thumb);
        var playBtn = document.createElement('div');
        playBtn.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:48px;height:48px;border-radius:50%;background:rgba(255,255,255,0.92);display:flex;align-items:center;justify-content:center;color:' + COLOR_NAVY + ';font-size:16px;';
        playBtn.innerHTML = '\u25b6';
        videoCard.appendChild(playBtn);
        videoCard.addEventListener('click', function() { openVideoModal(item.youtubeId); });
        aInner.appendChild(videoCard);
      } else if (item.type === 'founder') {
        // ── Outer card wrapper ──
        var founderCard = document.createElement('div');
        founderCard.style.cssText = 'background:#f5f7ff;border:1px solid #e0e4f5;border-radius:14px;padding:16px;';

        // ── Intro line ──
        var founderIntro = document.createElement('div');
        founderIntro.style.cssText = 'font-size:12px;color:' + COLOR_GRAY_TEXT + ';margin-bottom:12px;';
        founderIntro.textContent = 'A quick breakdown from our co-founder Michael.';
        founderCard.appendChild(founderIntro);

        // ── Video ──
        var founderVideo = document.createElement('video');
        founderVideo.src = 'https://cdn.shopify.com/videos/c/o/v/9aa7545465c74d36b1c0d3df524db685.mov';
        founderVideo.controls = true;
        founderVideo.playsInline = true;
        founderVideo.style.cssText = 'width:100%;border-radius:10px;display:block;background:#000;';
        founderCard.appendChild(founderVideo);

        // ── Founder block ──
        var founderBlock = document.createElement('div');
        founderBlock.style.cssText = 'display:flex;align-items:center;gap:12px;margin-top:14px;';

        var founderAvatar = document.createElement('img');
        founderAvatar.src = 'https://cdn.shopify.com/s/files/1/0917/6920/9148/files/hf_20260703_072758_d033f615-1000-4e0b-92a5-e6ec1da3609b.png?v=1783064330';
        founderAvatar.alt = 'Michael A.';
        founderAvatar.style.cssText = 'width:52px;height:52px;border-radius:50%;object-fit:cover;flex-shrink:0;border:2px solid #e0e4f5;';
        founderBlock.appendChild(founderAvatar);

        var founderInfo = document.createElement('div');
        var founderNameRow = document.createElement('div');
        founderNameRow.style.cssText = 'display:flex;align-items:center;gap:5px;';
        var founderName = document.createElement('span');
        founderName.style.cssText = 'font-size:14px;font-weight:700;color:' + COLOR_NAVY + ';';
        founderName.textContent = 'Michael A.';
        founderNameRow.appendChild(founderName);
        var tick = document.createElement('span');
        tick.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24"><circle cx="12" cy="12" r="12" fill="' + COLOR_BLUE + '"/><polyline points="6 12 10 16 18 8" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>';
        founderNameRow.appendChild(tick);
        founderInfo.appendChild(founderNameRow);
        var founderTitle = document.createElement('div');
        founderTitle.style.cssText = 'font-size:12px;color:' + COLOR_GRAY_TEXT + ';margin-top:2px;';
        founderTitle.textContent = 'PuraHome Co-Founder';
        founderInfo.appendChild(founderTitle);
        founderBlock.appendChild(founderInfo);
        founderCard.appendChild(founderBlock);

        // ── Spiel — two paragraphs ──
        var spiel1 = document.createElement('p');
        spiel1.style.cssText = 'font-size:13px;color:' + COLOR_NAVY + ';line-height:1.7;margin-top:14px;margin-bottom:0;';
        spiel1.textContent = 'We designed PuraHome because we saw all the benefits of a tap water filter. However, there was never one effective enough for our liking.';
        founderCard.appendChild(spiel1);

        var spiel2 = document.createElement('p');
        spiel2.style.cssText = 'font-size:13px;color:' + COLOR_NAVY + ';line-height:1.7;margin-top:10px;margin-bottom:0;';
        spiel2.innerHTML = '<strong>The result is Australia\'s most effective, convenient, and affordable water filter on the market.</strong> Check how it compares against all the other options in this video.';
        founderCard.appendChild(spiel2);

        aInner.appendChild(founderCard);
      }
      aWrap.appendChild(aInner);
      row.appendChild(aWrap);
      var startsOpen = item.open === true;
      var rowState = { aWrap: aWrap, toggleIcon: toggleIcon, open: startsOpen };
      if (startsOpen) {
        aWrap.style.maxHeight = '1200px';
        aWrap.style.marginTop = '10px';
        toggleIcon.style.transform = 'rotate(45deg)';
      }
      allRows.push(rowState);
      qRow.addEventListener('click', function() {
        var wasOpen = rowState.open;
        allRows.forEach(function(r) { r.open = false; r.aWrap.style.maxHeight = '0'; r.aWrap.style.marginTop = '0'; r.toggleIcon.style.transform = 'rotate(0deg)'; });
        if (!wasOpen) { rowState.open = true; aWrap.style.maxHeight = '1200px'; aWrap.style.marginTop = '10px'; toggleIcon.style.transform = 'rotate(45deg)'; }
      });
      container.appendChild(row);
    });
  }

  var NEWS_VIDEOS_BY_COUNTRY = {
    'AU': [
      { youtubeId: 'B3DUacSu3l0', network: '9NEWS',    networkColor: '#0d1b2a', blurb: 'Cancer-causing chemicals found in Australian tap water' },
      { youtubeId: 'WmOgCpF0Ag8', network: '7NEWS',    networkColor: '#e3001b', blurb: "Inside the labs testing Sydney's water for PFAS" },
      { youtubeId: 'XVeB2VwnyvM', network: 'ABC NEWS', networkColor: '#111111', blurb: 'Australia moves to tighten PFAS water limits' }
    ],
    'NZ': [
      { youtubeId: '5pBcZ3rDLRw', network: '1NEWS',   networkColor: '#0d1b2a', blurb: 'Over a million Kiwis lack safe drinking water' },
      { youtubeId: 'saLRGpeWmAE', network: '1NEWS',   networkColor: '#0d1b2a', blurb: "NZ's water system called a 'ticking time bomb'" },
      { youtubeId: '5qZ8uo4heaU', network: 'NEWSHUB', networkColor: '#1b1f24', blurb: "New Zealand's water supply is turning toxic" }
    ],
    'GB': [
      { youtubeId: 'nr3Vc6quuTE', network: 'BBC NEWS', networkColor: '#bb1919', blurb: 'What forever chemicals mean for your health' },
      { youtubeId: 'F9WOpTaTsHE', network: 'BBC NEWS', networkColor: '#bb1919', blurb: 'MPs push to ban forever chemicals in everyday items' },
      { youtubeId: 'KUBNSTmjeHE', network: 'BBC NEWS', networkColor: '#bb1919', blurb: 'Panorama investigates the truth about forever chemicals' }
    ],
    'default': [
      { youtubeId: 'PLACEHOLDER_1', network: 'NEWS', networkColor: '#1e2764', blurb: 'Investigation into tap water contaminants' },
      { youtubeId: 'PLACEHOLDER_2', network: 'NEWS', networkColor: '#1e2764', blurb: "What's really in your local water supply" },
      { youtubeId: 'PLACEHOLDER_3', network: 'NEWS', networkColor: '#1e2764', blurb: 'Experts explain hidden risks in tap water' }
    ]
  };

  function detectCountry() {
    try { if (window.Shopify && window.Shopify.country) return window.Shopify.country; } catch (e) {}
    var CURRENCY_TO_COUNTRY = { 'AUD': 'AU', 'NZD': 'NZ', 'GBP': 'GB' };
    return CURRENCY_TO_COUNTRY[getCurrency()] || 'default';
  }

  function buildNewsVideos() {
    var container = document.getElementById('ph2-news-videos');
    if (!container) { console.warn('[PH2] No #ph2-news-videos container found \u2014 news section skipped.'); return; }
    container.innerHTML = '';
    var heading = document.createElement('div');
    heading.style.cssText = 'font-size:22px;font-weight:800;color:' + COLOR_BLUE + ';margin-bottom:6px;';
    heading.textContent = 'Tap Water Is Making Headlines';
    container.appendChild(heading);
    var subheading = document.createElement('div');
    subheading.style.cssText = 'font-size:14px;color:' + COLOR_GRAY_TEXT + ';margin-bottom:18px;line-height:1.5;';
    subheading.textContent = 'Reporters across the country are uncovering what\'s really in our tap water. Here\'s what they found \u2014 and why more families are switching to filtered water now.';
    container.appendChild(subheading);
    var list = document.createElement('div');
    list.style.cssText = 'display:grid;grid-template-columns:repeat(3,1fr);gap:8px;';
    var videos = NEWS_VIDEOS_BY_COUNTRY[detectCountry()] || NEWS_VIDEOS_BY_COUNTRY['default'];
    videos.forEach(function(video) {
      var card = document.createElement('div');
      card.style.cssText = 'position:relative;width:100%;aspect-ratio:4/5;border-radius:10px;overflow:hidden;cursor:pointer;background:' + (video.networkColor || COLOR_NAVY) + ';display:flex;flex-direction:column;padding:12px 10px;box-sizing:border-box;';
      var networkLabel = document.createElement('div');
      networkLabel.style.cssText = 'color:#fff;font-weight:800;font-size:12.5px;letter-spacing:0.02em;text-align:center;';
      networkLabel.textContent = video.network;
      card.appendChild(networkLabel);
      var midOuter = document.createElement('div');
      midOuter.style.cssText = 'flex:1 1 auto;display:flex;align-items:center;justify-content:center;width:100%;';
      var midWrap = document.createElement('div');
      midWrap.style.cssText = 'position:relative;width:100%;aspect-ratio:16/9;border-radius:8px;overflow:hidden;';
      var thumbImg = document.createElement('img');
      thumbImg.src = 'https://img.youtube.com/vi/' + video.youtubeId + '/hqdefault.jpg';
      thumbImg.alt = video.blurb;
      thumbImg.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
      midWrap.appendChild(thumbImg);
      var playBtn = document.createElement('div');
      playBtn.style.cssText = 'position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:34px;height:34px;border-radius:50%;background:rgba(255,255,255,0.92);display:flex;align-items:center;justify-content:center;color:' + COLOR_NAVY + ';font-size:12px;';
      playBtn.innerHTML = '\u25b6';
      midWrap.appendChild(playBtn);
      midOuter.appendChild(midWrap);
      card.appendChild(midOuter);
      var blurbEl = document.createElement('div');
      blurbEl.style.cssText = 'color:rgba(255,255,255,0.85);font-size:10px;line-height:1.3;text-align:center;';
      blurbEl.textContent = video.blurb || '';
      card.appendChild(blurbEl);
      card.addEventListener('click', function() { openVideoModal(video.youtubeId); });
      list.appendChild(card);
    });
    container.appendChild(list);
  }

  function injectResponsiveStyles() {
    if (document.getElementById('ph2-responsive-styles')) return;
    var style = document.createElement('style');
    style.id = 'ph2-responsive-styles';
    style.textContent =
      '@media (max-width: 480px) {' +
      '  .ph2-card { padding:10px 12px !important; gap:9px !important; }' +
      '  .ph2-card-img { width:46px !important; height:46px !important; }' +
      '  .ph2-card-titlerow { gap:5px !important; }' +
      '  .ph2-card-label { font-size:15px !important; }' +
      '  .ph2-pct-pill { font-size:10px !important; padding:1.5px 6px !important; }' +
      '  .ph2-card-sublabel { display:none !important; }' +
      '  .ph2-card-sublabel-short { display:block !important; font-size:12.5px !important; }' +
      '  .ph2-card-perday-main { font-size:16px !important; }' +
      '  .ph2-card-billed { font-size:10.5px !important; }' +
      '  .ph2-card-rightcol { min-width:0 !important; }' +
      '  .ph2-best-ribbon { font-size:9px !important; padding:3px 11px !important; top:-8px !important; right:10px !important; border-radius:6px !important; }' +
      '  .ph2-sublabel-table { display:block !important; }' +
      '  .ph2-scarcity-wrap { width:88px !important; }' +
      '}';
    document.head.appendChild(style);
  }

  window.PuraHomeOffer = {
    isReady:          function() { return state.variants.length > 0; },
    getVariants:      function() { return state.variants.slice(); },
    getVariantMeta:   function(title) { return VARIANT_META[title] || null; },
    getCurrentVariant: getCurrentVariant,
    getCurrency:      function() { return state.currency; },
    getCtaLabel:      getCtaLabel,
    selectVariant: function(id) {
      var container = document.getElementById('ph2-cards');
      state.currentVariantId = id;
      if (container) highlightCard(id, container);
      applyPricing();
    },
    addToCart: performAddToCart,
    onChange: function(callback) {
      if (typeof callback === 'function') bridgeChangeListeners.push(callback);
    }
  };

  function init() {
    var container = document.getElementById('ph2-cards');
    if (!container) return;
    injectResponsiveStyles();
    var currency = getCurrency();
    var handle   = detectProductHandle();
    console.log('[PH2] Using product handle:', handle);
    buildUpsells();
    buildCtaSection();
    buildFAQ();
    buildNewsVideos();
    fetch('/products/' + handle + '.js')
      .then(function(r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function(product) {
        var priceMap = {};
        if (window.variantData && Array.isArray(window.variantData)) {
          window.variantData.forEach(function(v) { priceMap[v.id] = v; });
        }
        var merged = product.variants.map(function(v) {
          var p = priceMap[v.id] || {};
          return {
            id: v.id,
            title: v.title,
            featured_image: v.featured_image,
            available: v.available !== false,
            price: p.price !== undefined ? p.price : v.price / 100,
            compare_price: p.compare_price !== undefined ? p.compare_price : (v.compare_at_price ? v.compare_at_price / 100 : null),
          };
        });
        buildCards(merged, currency, container);
      })
      .catch(function(err) {
        console.error('[PH2] Failed to fetch /products/' + handle + '.js \u2014', err);
        if (window.variantData && Array.isArray(window.variantData) && window.variantData.length > 0) {
          var productVariants = (window.__st && window.__st.p && window.__st.p.variants) || null;
          var fallback = window.variantData.map(function(vd, idx) {
            var title = '', featuredImage = null;
            if (productVariants) {
              productVariants.forEach(function(pv) {
                if (pv.id == vd.id) { title = pv.title || pv.option1 || ''; featuredImage = pv.featured_image || null; }
              });
            }
            if (!title) title = VARIANT_ORDER[idx] || '';
            return { id: vd.id, title: title, featured_image: featuredImage, available: true, price: vd.price, compare_price: vd.compare_price };
          });
          buildCards(fallback, currency, container);
        } else {
          container.innerHTML = '<div style="color:#999;font-size:13px;padding:12px 0">Could not load options. Please refresh.</div>';
        }
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();